/* add polyfills for IE11 */
require('core-js/shim')

require('whatwg-fetch')
